<template>
  <div class="column">
    <header class="row no-wrap items-center q-px-lg" style="height: 36px">
      <div
        class="tlqn-admin-ml-edit-btn bg-white"
        v-if="!editMode && users.length"
        @click="beforeEdit()"
      >
        <q-icon name="fas fa-check-circle" size="12px" class="q-mr-sm" />
        <span>移除访员</span>
      </div>

      <div class="row items-center" v-else-if="users.length">
        <div class="row items-center">
          <div
            class="tlqn-admin-ml-edit-btn bg-white row items-center justify-center"
            style="width: 36px;height: 36px;"
            :class="{
              'tlqn-admin-ml-edit-btn-disable':
                prepareToBeRemovedUsers.length === 0,
            }"
            @click="prepareToBeRemovedUsers.length ? removeGroupMembers() : ''"
          >
            <q-icon name="fas fa-trash" size="14px" color="red" />
          </div>
          <span class="text-caption q-ml-xs">
            从分组中删除选中的访员
          </span>
        </div>
        <div class="row items-center q-ml-lg">
          <div
            class="tlqn-admin-ml-edit-btn bg-white row items-center justify-center"
            style="width: 36px;height: 36px;"
            @click="cancelEdit"
          >
            <q-icon name="fas fa-times-circle" size="14px" color="green" />
          </div>
          <span class="text-caption q-ml-xs">取消</span>
        </div>
      </div>
    </header>

    <q-scroll-area v-if="users && users.length" class="column col-grow q-my-md">
      <main class="q-px-lg q-py-md">
        <q-list>
          <q-item
            :to="{
              query: {
                ...$route.query,
                _gu: user.id,
              },
            }"
            :class="{
              'tlqn-admin-group-member-list-item-active':
                $route.query._gu === user.id,
            }"
            clickable
            v-for="(user, index) in users"
            :key="user.id"
            class="row no-wrap items-center tlqn-admin-group-member-list-item q-mb-sm"
          >
            <div
              class="tlqn-agmli-option q-pr-sm"
              :class="{
                'tlqn-agmli-option-show': editMode,
              }"
              :style="{
                transition: `all 0.3s ease ${(index * 20) / 1000}s`,
              }"
            >
              <q-checkbox
                :disable="
                  user.samples &&
                    user.samples.some((s) => s.sample_status === 2)
                "
                v-model="prepareToBeRemovedUsers"
                :val="user.id"
              >
                <q-tooltip
                  v-if="
                    user.samples &&
                      user.samples.some((s) => s.sample_status === 2)
                  "
                >
                  {{ user.nickname }} 有样本正在调查中，无法移除
                </q-tooltip>
              </q-checkbox>
            </div>

            <!-- 头像 + 角色 -->
            <div
              class="tlqn-agmli-avatar column items-center justify-center q-mr-md"
            >
              <q-avatar class="tlqn-agmli-avatar_display">
                {{ (user.nickname || "/").substr(0, 1) }}
              </q-avatar>
              <q-badge
                text-color="white"
                color="primary"
                v-if="user.roles.some((r) => r.value === '002')"
                class="q-mt-sm"
              >
                组长
              </q-badge>
            </div>

            <!-- 个人信息 + 进度 -->
            <div
              class="tlqn-agmli-info-progress col-grow column justify-between full-height q-py-xs"
            >
              <span class="tlqn-agmli-info">
                {{ user.nickname }}
              </span>

              <div class="tlqn-agmli-progress">
                <span>
                  完成总体样本
                  {{
                    user.samples.filter(
                      (s) => s.sample_status != 2 && s.sample_status != 1
                    ).length
                  }}
                  /
                  {{ user.samples.length }}
                </span>
                <LineProgress
                  :delay="(index * 20) / 1000"
                  :progress="
                    (user.samples.filter(
                      (s) => s.sample_status != 2 && s.sample_status != 1
                    ).length /
                      user.samples.length) *
                      100
                  "
                />
              </div>
            </div>

            <!-- 今日完成 -->
            <div
              class="finished-today column items-center justify-between full-height q-pt-md"
            >
              <div class="row items-center">
                <q-icon
                  name="fas fa-calendar-check"
                  size="10px"
                  color="secondary"
                  class="q-mr-xs"
                ></q-icon>
                <span
                  style="font-size: 0.7rem"
                  class="text-bold text-secondary"
                >
                  今日完访
                </span>
              </div>

              <div
                class="text-bold text-secondary"
                style="font-size: 2rem;line-height: 1"
              >
                <FinishTodayCount :samples="user.samples || []" />
              </div>
            </div>

            <div style="width: 50px;" class="row justify-end">
              <q-icon
                :style="{
                  opacity: $route.query._gu === user.id ? 1 : 0,
                  visibility:
                    $route.query._gu === user.id ? 'visible' : 'hidden',
                }"
                class="tl-transition-1"
                name="fas fa-chevron-right"
                color="secondary"
                size="1.2rem"
              />
            </div>
          </q-item>
        </q-list>
      </main>
    </q-scroll-area>
    <main v-else class="column col-grow q-my-md justify-center items-center">
      <Empty text="请先添加成员" />
    </main>

    <footer class="row no-wrap justify-end items-center">
      <q-btn
        flat
        class="text-green bg-white shadow-22 q-mr-md"
        @click="showAddMemberDialog = true"
        :disable="adminStatusStore[REMOVING_GROUP_MEMBERS]"
      >
        <q-icon name="fas fa-user-plus" size="12px" class="q-mr-sm" />
        <span>添加成员</span>
      </q-btn>
      <q-btn
        flat
        :disable="true"
        class="text-red bg-white shadow-22"
        @click="showRemoveGroupDialog = true"
      >
        <q-icon name="fas fa-trash" size="12px" class="q-mr-sm"></q-icon>
        <span>删除分组</span>
      </q-btn>
    </footer>

    <q-dialog v-model="showRemoveGroupDialog" persistent>
      <q-card class="q-pa-lg">
        <q-card-section class="row items-center text-red-5 text-bold">
          <q-icon
            name="fas fa-exclamation-triangle"
            size="30px"
            class="q-mr-xl"
          />
          <span>确定要删除当前分组吗？删除后无法恢复，请谨慎操作！</span>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn
            flat
            label="取消"
            color="primary"
            v-close-popup
            :disable="removingGroup"
          />
          <q-btn
            flat
            label="确认删除"
            class="bg-red text-white"
            @click="deleteGroup"
            :loading="removingGroup"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog v-model="showAddMemberDialog" persistent>
      <UserList
        @cancel="showAddMemberDialog = false"
        @updated="onGroupMemberUpdated"
        :group-id="groupId"
      />
    </q-dialog>
  </div>
</template>

<script>
import AdminCommonStatus from "@/views/Admin/mixins/status.mixin";
import { REMOVING_GROUP_MEMBERS } from "@/status/admin.status";
import { updateGroupMember } from "@/api/endpoints/group/updateGroupMember";
import { deleteGroup } from "@/api/endpoints/group/deleteGroup";
import { Prop } from "vue-property-decorator";
export default {
  mixins: [AdminCommonStatus],
  components: {
    Empty: () => import("@/components/Empty"),
    UserList: () => import("./UserList"),
    LineProgress: () => import("@/components/progress-bar/LineProgress"),
    FinishTodayCount: () => import("./FinishTodayCount"),
  },
  props: {
    users: {
      type: Array,
      default: () => [],
    },
    groupId: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      showAddMemberDialog: false,
      showRemoveGroupDialog: false,
      // editMode: false,

      prepareToBeRemovedUsers: [],
      REMOVING_GROUP_MEMBERS,
      removingGroup: false,
    };
  },

  computed: {
    editMode() {
      return this.adminStatusStore[REMOVING_GROUP_MEMBERS];
    },
  },

  methods: {
    onGroupMemberUpdated() {
      this.$emit("updated");
      this.showAddMemberDialog = false;
    },

    cancelEdit() {
      this.prepareToBeRemovedUsers = [];
      this.updateAdminCommonStatus(REMOVING_GROUP_MEMBERS, false);
    },

    beforeEdit() {
      this.updateAdminCommonStatus(REMOVING_GROUP_MEMBERS, true);
    },

    /**
     * 移除选中的组员
     */
    async removeGroupMembers() {
      const { prepareToBeRemovedUsers } = this;
      try {
        const response = await updateGroupMember(this.groupId, {
          remove: prepareToBeRemovedUsers,
        });
        if (response.status && response.status != 1) {
          this.$q.notify({
            type: "danger",
            message: response.detail || response.message,
          });
        } else {
          this.$q.notify({
            type: "success",
            message: "已移除",
          });
          this.$emit("updated");
          this.cancelEdit();
        }
      } catch (err) {
        console.log(err);
        this.$q.notify({
          type: "danger",
          message: "移除访员时发生未知错误",
        });
      }
    },

    /**
     * 删除当前分组
     */
    async deleteGroup() {
      this.removingGroup = true;
      try {
        const response = await deleteGroup(this.groupId);
        if (response.status || response.error) {
          this.$q.notify({
            type: "danger",
            message: response.detail || response.message,
          });
        } else {
          this.$q.notify({
            type: "success",
            message: "已删除",
          });
        }
      } catch (err) {
        console.log(err);
        this.$q.notify({
          type: "danger",
          message: "删除分组时发生未知错误",
        });
      } finally {
        this.removingGroup = false;
        this.$emit("deleted");
        this.showRemoveGroupDialog = false;
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/quasar";
@import "@/styles/animate";

.tlqn-admin-ml-edit-btn {
  /* box-shadow: $shadow-1; */
  border-radius: 10px;
  padding: 6px 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  &:hover {
    box-shadow: $shadow-22;
  }
}
.tlqn-admin-ml-edit-btn-disable {
  cursor: not-allowed;
  position: relative;
  &::after {
    content: "";
    position: absolute;
    border-radius: inherit;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.5);
    z-index: 1;
    left: 0;
    top: 0;
  }
}

.tlqn-admin-group-member-list-item {
  overflow: hidden;
  height: 90px;
  border-radius: 2 * $generic-border-radius !important;
  color: unset !important;

  &.tlqn-admin-group-member-list-item-active {
    background-color: #fff;
    box-shadow: $shadow-22;
  }
}

.tlqn-agmli-avatar_display {
  background-color: rgba($primary, 0.2);
  color: $primary;
  font-weight: bold;
}
.tlqn-agmli-option {
  width: 50px;
  margin-left: -50px;
  visibility: hidden;
  flex-shrink: 0;
  &.tlqn-agmli-option-show {
    margin-left: 0;
    visibility: visible;
  }
}

.tlqn-agmli-info-progress {
  .tlqn-agmli-info {
    font-size: 1.2rem;
    font-weight: bold;
  }

  .tlqn-agmli-progress {
    font-size: 0.75rem;
    color: $grey-8;
  }
}
</style>
